import React from 'react';

import BaseComponent from '../../baseClasses/BaseComponent'; // Change to point to the right level in the file structure
import ComboBox from '../ComboBox';

// Change DialogButton to the appropriate name
class CountryComboBox extends BaseComponent {
  constructor(props) {
    super(props);
    let currentOption = props.currentOption ? props.currentOption : 'United States';
    this.state = {
      countryList: [
        'United States',
        'Canada',
      ],
      selected: currentOption,
    };
  }

  createCountryOptions(){

    let countryList  = this.state.countryList.map((country) => {
      return { type: country, name: country };
    });
    return countryList;
  }

  handleCountryChange(type, option){
    let country = this.state.countryList.filter(function(country){
      return country == option.name;
    });
    country = country[0];
    this.setState({
      selected: country,
    });

    this.props.handleCountryChange(country);
  }

  render() {
    let { height, width, hasBorder, defaultText, displayFontStyle, currentOption, maxHeight, top, left, label, tabIndex,
      makeAbsolute, underlined, menuUp } = this.props;

    height = this.props.height ? this.props.height : null;
    width = this.props.width ? this.props.width : null;
    hasBorder = this.props.hasBorder ? this.props.hasBorder : null;
    defaultText = this.props.defaultText ? this.props.defaultText : null;
    displayFontStyle = this.props.displayFontStyle ? this.props.displayFontStyle : null;
    currentOption = { type: this.props.currentOption ? this.props.currentOption : this.state.selected };
    currentOption.name = currentOption.type;
    maxHeight = this.props.maxHeight ? this.props.maxHeight : null;
    top = this.props.top ? this.props.top : null;
    left = this.props.left ? this.props.left : null;
    makeAbsolute = this.props.makeAbsolute ? this.props.makeAbsolute : null;
    label = this.props.label ? this.props.label : null;
    tabIndex = this.props.tabIndex ? this.props.tabIndex : null;
    underlined = this.props.underlined ? this.props.underlined : null;
    menuUp = this.props.menuUp ? this.props.menuUp : null;

    let options = this.createCountryOptions();

    return (
      // Replace with the appropriate HTML
      <ComboBox id={'countryPicker'} options={options} height={height} width={width} hasBorder={hasBorder} defaultText={defaultText} 
      currentOption={currentOption} displayFontStyle={displayFontStyle } handleSelection={this.handleCountryChange}
      maxHeight={maxHeight} top={top} left={left} makeAbsolute={makeAbsolute} label={label} underlined={underlined}
      tabIndex={tabIndex} menuUp={menuUp}
    />
    );
  }
}

export default (CountryComboBox);



// WEBPACK FOOTER //
// ./src/components/CountryComboBox/index.js